exports = module.exports = require("../../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".people4[data-v-38beaa72]{background:#f2f3f5;padding:8px;border-radius:3px;margin-top:10px}.people4 h4[data-v-38beaa72]{margin:8px 0}.people4 h5[data-v-38beaa72]{margin:2px 0;color:#5e6d82}.people4 p[data-v-38beaa72]{color:#474747;font-size:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38beaa72","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/people4.vue
// module id = 169
// module chunks = 1